// Role definitions for FulfillFlow. Permission logic is intentionally deferred;
// this module only establishes the architecture future sprints will build on.

export const ROLES = {
  PRODUCT_OWNER: "PRODUCT_OWNER",
  THREE_PL_OWNER: "THREE_PL_OWNER",
  WAREHOUSE_MANAGER: "WAREHOUSE_MANAGER",
  WAREHOUSE_STAFF: "WAREHOUSE_STAFF",
  VA_AGENCY_OWNER: "VA_AGENCY_OWNER",
  VA_MANAGER: "VA_MANAGER",
  VA_STAFF: "VA_STAFF",
  CLIENT: "CLIENT",
};

export const ROLE_LABELS = {
  PRODUCT_OWNER: "Product Owner",
  THREE_PL_OWNER: "3PL Owner",
  WAREHOUSE_MANAGER: "Warehouse Manager",
  WAREHOUSE_STAFF: "Warehouse Staff",
  VA_AGENCY_OWNER: "VA Agency Owner",
  VA_MANAGER: "VA Manager",
  VA_STAFF: "VA Staff",
  CLIENT: "Client",
};

export const ROLE_ORDER = [
  ROLES.PRODUCT_OWNER,
  ROLES.THREE_PL_OWNER,
  ROLES.WAREHOUSE_MANAGER,
  ROLES.WAREHOUSE_STAFF,
  ROLES.VA_AGENCY_OWNER,
  ROLES.VA_MANAGER,
  ROLES.VA_STAFF,
  ROLES.CLIENT,
];

export function roleLabel(role) {
  return ROLE_LABELS[role] || role;
}
